import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { localStorageConstants } from '../services';
import { firstValueFrom, take } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { UsersService } from 'src/app/modules/users/services/users.service';

export const cacheResolver: ResolveFn<boolean> = async (route, state) => {
  const azureId = getAzureIdForUser();
  await populateUserFacilitiesCache(azureId);
  return true;
};

function getAzureIdForUser(): string {
  const authService = inject(MsalService);
  return authService.instance.getAllAccounts()[0].homeAccountId.split('.')[0];
}

async function populateUserFacilitiesCache(azureId: string): Promise<void> {
  const cached = localStorage.getItem(
    localStorageConstants.USER_FACILITIES_KEY,
  );
  const parsed = cached ? JSON.parse(cached) : null;
  if (Array.isArray(parsed) && parsed.length > 0) {
    return;
  }
  const userService = inject(UsersService);
  const user = await firstValueFrom(userService.getUserByAzureId(azureId));
  localStorage.setItem(
    localStorageConstants.USER_FACILITIES_KEY,
    JSON.stringify(user.FacilityAssignments),
  );
}
